import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Icon
} from 'semantic-ui-react';
import PanelLayout from '../panel/layout';
import { ConnectedPapersMenuAdapter } from './papers_menu_adapter_connector';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';
import More from '../assets/more';
import Remove from '../assets/remove';
import Bag from '../assets/bag';
import WorkTitle from './work_title';
import Const from '../../config/const';
import { sortedHumanSizes } from '../../config/utils';

export default class WorkDetails extends PureComponent {
  static propTypes = {
    workId: PropTypes.number,
    workSizeId: PropTypes.number,
    frameId: PropTypes.number,
    nonGlare: PropTypes.bool,
    index: PropTypes.number,
    workSizes: PropTypes.array,
    setWorkSize: PropTypes.func.isRequired,
    removeFromCanvas: PropTypes.func.isRequired,
    setFrame: PropTypes.func.isRequired,
    setNonGlare: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    showMoreLikeThis: PropTypes.func.isRequired,
    addToCart: PropTypes.func.isRequired,
    framingOptions: PropTypes.array.isRequired,
    landscape: PropTypes.bool,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    authorName: PropTypes.string,
    isHidden: PropTypes.bool,
    useOriginalFrameSelector: PropTypes.bool
  };

  static defaultProps = {
    useOriginalFrameSelector: false
  };

  constructor(props) {
    super(props);
    this.removeWork = this.removeWork.bind(this);
    this.setWorkSize = this.setWorkSize.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.showMoreLikeThis = this.showMoreLikeThis.bind(this);
    this.toggleNonGlare = this.toggleNonGlare.bind(this);
  }

  toggleNonGlare = () => {
    const { setNonGlare, index, nonGlare } = this.props;
    setNonGlare(!nonGlare, index);
  }

  removeWork = () => {
    const { hide, index, removeFromCanvas } = this.props;
    removeFromCanvas(index);
    hide();
  }

  setWorkSize = (newId) => {
    const {
      index, setWorkSize
    } = this.props;
    setWorkSize(newId, index);
  }

  addToCart = () => {
    const { addToCart, index } = this.props;
    addToCart(index);
  }

  showMoreLikeThis = () => {
    const { showMoreLikeThis, workId, index } = this.props;
    showMoreLikeThis(workId, index, Const.moreLikeThisSources.canvas);
  }

  renderWorkSizes() {
    const {
      workSizes, workSizeId, landscape
    } = this.props;
    return sortedHumanSizes(workSizes || [], landscape).map(([hs, ws]) => (
      <Button
        key={ ws.id }
        onClick={ () => this.setWorkSize(ws.id) }
        color={ ws.id === workSizeId ? 'black' : null }
      >
        { ws.isHidden ? <Icon name="eye slash" /> : null }
        { hs }
      </Button>
    ));
  }

  render() {
    const {
      workId, hide, title, authorName,
      imageUrl, isHidden
    } = this.props;
    if (!workId) {
      return null;
    }

    const renderTitle = imageUrl ? (
      <WorkTitle
        imageUrl={ imageUrl }
        title={ title }
        authorName={ authorName }
        isHidden={ isHidden }
      />
    ) : null;

    return (
      <PanelLayout onClose={ hide } title="Design">
        <div className={ classes.content }>
          <div className={ shared.holder }>
            <div className={ classes.scroll }>
              <div className={ classes.actions }>
                <button className={ classes.action } type="button" name="more" onClick={ this.showMoreLikeThis }>
                  <More fill="#000" />
                  More like this
                </button>
                <div className={ classes.divider } />
                <button className={ classes.action } type="button" name="more" onClick={ this.addToCart }>
                  <Bag fill="#000" />
                  Add to cart
                </button>
                <div className={ classes.divider } />
                <button className={ classes.action } type="button" name="more" onClick={ this.removeWork }>
                  <Remove fill="#000" />
                  Remove
                </button>
              </div>
              { renderTitle }
              <div className={ classes.options }>
                { this.renderWorkSizes() }
              </div>
              <ConnectedPapersMenuAdapter showNoFrameOption index={ this.props.index } />
            </div>
          </div>
        </div>
      </PanelLayout>
    );
  }
}
